import { render, staticRenderFns } from "./ReceivedSamplesTable.vue?vue&type=template&id=469e8643&"
import script from "./ReceivedSamplesTable.vue?vue&type=script&lang=js&"
export * from "./ReceivedSamplesTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedSamplesTable.vue?vue&type=style&index=0&id=469e8643&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports